<template>
  <div
    class="portfolio-pages-wrapper section-space--ptb_100 border-bottom gray-gradient"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div
            class="section-title-wrapper text-center section-space--mb_60 wow move-up"
          >
            <h2 class="section-title font-weight--bold mb-15">Our Products</h2>
            <h6>
              Besides building our clients customized solutions, we also have
              our own in house flagship off the shelf products which include:
            </h6>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div
          class="col-lg-4 col-md-6 wow move-up mb-30"
          v-for="(product, key) in products"
          :key="key"
        >
          <div
            class="portfolio-grid-caption text-center justify-content-center align-items-center"
          >
            <router-link
              :to="{ name: product.page }"
              class="single-grid-caption"
            >
              <div class="single-portfolio__thumbnail">
                <img
                  class="img-fluid"
                  :src="product.image"
                  :alt="product.name"
                />
              </div>
            </router-link>
            <div class="post-info">
              <h5 class="post-title font-weight--bold">
                <router-link to="">
                  {{ product.name }}
                </router-link>
              </h5>
              <br />
              <div class="post-categories">
                <p>{{ product.summary }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import products from "../data/products";

export default {
  components: {},

  data() {
    return {
      products,
    };
  },
};
</script>
